import React from "react";

const FeaturesSection = () => {
  // 6 distinct steps – no duplication
  const steps = [
    "Create a Circle",
    "Invite Members",
    "Set Contribution Rules",
    "Make Contributions",
    "Rotate Payouts",
    "Complete the Cycle",
  ];

  // Duplicate the array only for the seamless loop (CSS handles the rest)
  const marqueeItems = [...steps, ...steps];

  return (
    <section
      id="NewFeatures"
      className="px-4 pt-16 sm:pt-6 lg:pt-8 border-t border-gray-50 overflow-hidden" style={{ backgroundColor: '#F8FAFC' }}
    >
      <style>{`
        @keyframes ajoMarqueeScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .ajo-marquee-track {
          display: flex;
          gap: 1rem;
          align-items: center;
          animation: ajoMarqueeScroll 28s linear infinite;
          width: max-content;
          padding-top: 1rem;
        }

        .ajo-marquee-track:hover {
          animation-play-state: paused;
        }

        .ajo-marquee-pill {
          flex-shrink: 0;
          min-height: 72px;
          min-width: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 9999px;
          border: 1px solid #e5e7eb;
          background-color: white;
          padding: 0.75rem 1.5rem;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.025);
          transition: all 0.3s ease;
        }

        .ajo-marquee-pill:hover {
          border-color: #818cf8;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02);
          transform: translateY(-4px) scale(1.02);
        }

        .ajo-marquee-arrow {
          flex-shrink: 0;
          display: flex;
          height: 2.5rem;
          width: 2.5rem;
          align-items: center;
          justify-content: center;
          border-radius: 9999px;
          background-color: #f3f4f6;
          color: #6b7280;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }

        .ajo-marquee-arrow svg {
          width: 1.25rem;
          height: 1.25rem;
        }

        @media (max-width: 640px) {
          .ajo-marquee-track {
            gap: 0.75rem;
            animation-duration: 40s; /* slower for readability */
          }
          .ajo-marquee-pill {
            min-width: 140px;
            min-height: 60px;
            padding: 0.5rem 1rem;
            font-size: 0.875rem;
          }
          .ajo-marquee-arrow {
            height: 2rem;
            width: 2rem;
          }
          .ajo-marquee-arrow svg {
            width: 1rem;
            height: 1rem;
          }
        }
      `}</style>

      <div className="text-center mb-12">
        <h1 className="text-2xl font-medium text-gray-900 sm:text-4xl lg:text-5xl">
          Streamline Ajo savings with{" "}
          <span className="text-gray-600">thrift‑friendly workflows</span>
        </h1>
        <p className="mt-6 text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
          With Ajo, traditional thrift meets modern convenience. Move from
          starting a thrift circle, to contributing and rotating, to completing
          each cycle with clarity.
        </p>
      </div>

      {/* Marquee container */}
      <div className="relative mx-auto max-w-7xl overflow-hidden">
        <div className="ajo-marquee-track">
          {marqueeItems.map((step, index) => {
            // Show arrow after every step except the last in the duplicated set
            // For the duplicated half, we still want arrows between them
            const showArrow = index % steps.length !== steps.length - 1;
            return (
              <React.Fragment key={`${step}-${index}`}>
                <div className="ajo-marquee-pill">
                  <span className="text-center text-sm font-semibold text-gray-800 sm:text-base">
                    {step}
                  </span>
                </div>
                {showArrow && (
                  <div className="ajo-marquee-arrow" aria-hidden="true">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14" />
                      <path d="m13 6 6 6-6 6" />
                    </svg>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
